import { take, catchError, map, switchMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { Action, Store, select } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { getSelectedBusinessLineAndShippingCondition, OrderBuilderState } from '../../../../../reducers';
import { IEffect } from '../../../../../../shared/modules/dynamic-effects/effect.interface';
import {
  AnticipatedInvoiceLoadCompleteAction,
  AnticipatedInvoiceLoadFailAction,
  AnticipatedInvoiceRemoveSelectedAction,
  AnticipatedInvoiceResetAction,
} from '../../../actions/anticipated-invoice-actions/anticipated-invoice.actions';
import { IShipmentLocation } from '@cemex-core/cmx-api/models/shipment-location/shipment-location';
import { JOBSITE_SET, JobsiteSetAction } from '../../../actions/jobsite-actions/jobsite.actions';
import { SalesDocumentManagementService } from '@cemex-core/cmx-api';
import { ISalesDocumentsReq, ISalesDocumentsRes } from '@cemex-core/cmx-api/models/sales-document-management';
import { RESET_BUILDER } from '../../../../../actions/order-builder.actions';

// RETAIL::TODO: move to cemex core
enum ContractType {
  ZCA = 'ZCA',
}

@Injectable()
export class AnticipatedInvoiceLoadEffects implements IEffect {
  anticipatedInvoiceLoad$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(JOBSITE_SET),
      switchMap((payload: JobsiteSetAction) => {
        this.store.dispatch(new AnticipatedInvoiceRemoveSelectedAction(null));
        return this.store.pipe(
          select(getSelectedBusinessLineAndShippingCondition),
          take(1),
          switchMap(
            (response: { productLineId: number; shippingConditionCode: string; shippingConditionId: number }) => {
              return this.salesDocumentsService
                .getSalesDocuments(this.prepareAnticipatedInvoiceLoadRequest(payload.payload, response))
                .pipe(
                  map((salesDocumentsRes: ISalesDocumentsRes) => {
                    return new AnticipatedInvoiceLoadCompleteAction(salesDocumentsRes);
                  }),
                  catchError((error) => of(new AnticipatedInvoiceLoadFailAction(error))),
                );
            },
          ),
        );
      }),
    ),
  );

  resetAnticipatedInvoiceState$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(RESET_BUILDER),
      map(() => new AnticipatedInvoiceResetAction()),
    ),
  );

  constructor(
    private store: Store<OrderBuilderState>,
    private actions$: Actions,
    private salesDocumentsService: SalesDocumentManagementService,
  ) {}

  private prepareAnticipatedInvoiceLoadRequest(
    selectedJobsite: IShipmentLocation,
    response: { productLineId: number; shippingConditionCode: string; shippingConditionId: number },
  ): ISalesDocumentsReq {
    return {
      salesDocumentTypeId: 1,
      jobSiteId: selectedJobsite.shipmentLocationId,
      productLineId: response.productLineId,
      contractType: ContractType.ZCA,
      shippingConditionId: response.shippingConditionId,
    };
  }
}
